import { createSelector } from 'reselect';

const selectGrns = (state: any) => state.grns;


export const selectGrnsCurrentItem = createSelector([selectGrns], (grns) => grns.current);

export const selectGrnsListItems = createSelector([selectGrns], (grns) => grns.list);

export const selectGrnsItemById = (itemId: any) =>
    createSelector(selectGrnsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGrnsQueryItems = createSelector([selectGrns], (grns) => grns.query);

export const selectGrnsCreatedItem = createSelector([selectGrns], (grns) => grns.create);

export const selectGrnsUpdatedItem = createSelector([selectGrns], (grns) => grns.update);

export const selectGrnsReadItem = createSelector([selectGrns], (grns) => grns.read);

export const selectGrnsDeletedItem = createSelector([selectGrns], (grns) => grns.delete);

export const selectGrnsSearchedItems = createSelector([selectGrns], (grns) => grns.search);

export const selectGrnsItemsCount = createSelector([selectGrns], (grns) => grns.count);

export const selectGrnsItemsFilter = createSelector([selectGrns], (grns) => grns.filter);